/**
 * API 설정
 * REACT_APP_ENV에 따라 baseURL 결정
 */

const isDevelopment = import.meta.env.VITE_ENV === 'development';

export const API_BASE_URL = isDevelopment
  ? 'http://localhost:8000/api/v1'
  : import.meta.env.VITE_API_BASE_URL || 'https://pharm.mungpay.com:8000/api/v1';
